import {
  IconBrandDiscord,
  IconBrandTwitch,
  IconCoins,
  IconDownload,
  IconGift,
  IconHelp,
  IconHome,
  IconInfoSquareRounded,
  IconMessages,
  IconNews,
  IconPremiumRights,
  IconSettings,
  IconStar,
  IconUser,
} from '@tabler/icons-react';

export const links = [
  { link: '/', label: 'Home', icon: IconHome },
  { link: '/news', label: 'News', icon: IconNews },
  {
    link: '#useful',
    label: 'Useful',
    icon: IconInfoSquareRounded,
    links: [
      { link: '/monitoring/online', label: 'Online list' },
      { link: '/monitoring/dungeons', label: 'Dungeon Queue' },
      { link: '/monitoring/battlegrounds', label: 'Battleground Queue' },
      { link: '/items/all', label: 'Item DB' },
      {
        link: 'https://tera-asura.ru/static/files/TeraToolboxSetup.exe',
        label: 'Toolbox',
        noPrefetch: true,
      },
      { link: 'https://teralogs.com/asura', label: 'TERA Logs', noPrefetch: true },
    ],
  },
  { link: '/download', label: 'Download', icon: IconDownload },
  {
    link: '#help',
    label: 'Help',
    icon: IconHelp,
    links: [
      { link: '/faq', label: 'FAQ' },
      { link: '/terms', label: 'Terms' },
      { link: '/cabinet/support', label: 'Support' },
    ],
  },
  {
    link: '#mmotop',
    label: 'MMOTOP',
    icon: IconStar,
    links: [
      { link: '/mmotop-guide', label: 'MMOTOP Guide' },
      {
        link: 'https://all.mmotop.ru/servers/34907/votes/new',
        label: 'Vote now',
        noPrefetch: true,
      },
    ],
  },
];

export const userLinks = [
  { link: '/cabinet/profile', label: 'Profile', icon: IconUser },
  { link: '/cabinet/support', label: 'Support', icon: IconMessages },
  { link: '/cabinet/donation', label: 'Donation', icon: IconCoins },
  { link: '/cabinet/premium', label: 'Premium', icon: IconPremiumRights },
  { link: '/cabinet/promo', label: 'Promotion', icon: IconGift },
  { link: '/cabinet/discord', label: 'Discord Bonus', icon: IconBrandDiscord },
  { link: '/cabinet/twitch', label: 'Twitch Bonus', icon: IconBrandTwitch },
  { link: '/cabinet/settings', label: 'Settings', icon: IconSettings },
];
